export default {
  'warehouse.tab.basic': 'Basic',
  'warehouse.tab.memo': 'Memo',
  'warehouse.field.file_no': 'File No.',
  'warehouse.field.post_date': 'Post Date',
  'warehouse.field.in_date': 'In Date',
  'warehouse.field.out_date': 'Out Date',
  'warehouse.field.order_no': 'Order No.',
  'warehouse.field.order_date': 'Order Date',
  'warehouse.field.container_no': 'Container No.',
  'warehouse.field.truck_bl_no': 'Truck B/L No.',
  'warehouse.field.expect_date': 'Expect Date',
  'warehouse.field.expiration_date': 'Expiration Date',
  'warehouse.field.warehouse_status': 'Status',
  'warehouse.field.pallet': 'Pallet',
  'warehouse.field.pallet_remark': 'Pallet Remark',
  'warehouse.field.remark': 'Remark',
  'warehouse.field.bill_to': 'Bill To',
  'warehouse.field.ship_from': 'Ship From',
  'warehouse.field.ship_to': 'Ship To',
  'warehouse.field.trucker': 'Trucker',
  'warehouse.field.bl_no': 'B/L No.',
  'warehouse.line.sku_no': 'SKU No.',
  'warehouse.line.customer_po': 'Customer P.O.',
  'warehouse.line.product_description': 'Product Description',
  'warehouse.line.order_po_no': 'Order P.O. No.',
  'warehouse.line.order_qty': 'Order Qty',
  'warehouse.line.qty': 'Qty',
  'warehouse.line.qty_unit': 'Qty Unit',
  'warehouse.line.pcs': 'PCS',
  'warehouse.line.pack': 'Pack',
  'warehouse.line.pack_unit': 'Pack Unit',
  'warehouse.line.pack_2': 'Pack 2',
  'warehouse.line.pack_2_unit': 'Pack 2 Unit',
  'warehouse.line.pallet': 'Pallet',
  'warehouse.line.weight': 'Weight',
  'warehouse.line.measurement': 'Measurement',
  'warehouse.line.shipping_qty': 'Shipping QTY',
  'warehouse.line.allocated_qty': 'Allocated Qty',
  'warehouse.line.items': 'Items',
  'warehouse.line.add': 'Add Line',
  'warehouse.status.pre_receiving': 'Pre-Receiving',
  'warehouse.status.receiving': 'Receiving',
  'warehouse.status.received': 'Received',
  'warehouse.status.pre_shipping': 'Pre-Shipping',
  'warehouse.status.shipping': 'Shipping',
  'warehouse.status.shipped': 'Shipped',
  'warehouse.field.customer': 'Customer',
  'warehouse.field.quotation': 'Quotation No.',
  'warehouse.line.total': 'Total',
  'warehouse.line.inventory': 'Inventory',
  // Item 管理
  'warehouse.item.customer': 'Customer',
  'warehouse.item.vendor': 'Vendor',
  'warehouse.item.item_no': 'SKU No.',
  'warehouse.item.description': 'Product Description',
  'warehouse.item.created_at': 'Created At',
  'warehouse.item.upc_ean': 'UPC/EAN',
  'warehouse.item.mpn': 'MPN',
  'warehouse.item.hts_code': 'HTS Code',
  'warehouse.item.qty_unit': 'Qty Unit',
  'warehouse.item.inner_pack': 'Inner Pack',
  'warehouse.item.weight': 'Weight',
  'warehouse.item.weight_unit': 'Weight Unit',
  'warehouse.item.measurement': 'Measurement',
  'warehouse.item.measure_unit': 'Measure Unit',
  'warehouse.item.dimension': 'Dimension',
  'warehouse.item.length': 'Length',
  'warehouse.item.width': 'Width',
  'warehouse.item.height': 'Height',
  'warehouse.item.remark': 'Remark',
  'warehouse.item.status': 'Status',
  'warehouse.item.list_title': 'Item List',
  'warehouse.item.add_title': 'New Item',
  'warehouse.item.create.success': 'Item created',
  'warehouse.item.update.success': 'Item updated',
  'warehouse.item.delete.success': 'Item deleted',
  'warehouse.item.delete.confirm': 'Delete this item?',
  // Inventory
  'warehouse.inv.on_hand': 'On Hand Qty',
  'warehouse.inv.allocated': 'Allocated Qty',
  'warehouse.inv.available': 'Available Qty',
  'warehouse.inv.date': 'Date',
  'warehouse.inv.file_no': 'File No.',
  'warehouse.inv.direction': 'In/Out',
  'warehouse.inv.status_group': 'Status Group',
};
